import { useCallback, useState } from 'react';
import { downloadReceiptSummary } from '../services/ProfessionalPaymentController';
import { parseApiError } from '../services/apiError';
import useNotify from './useNotify';

/**
 * Descarga del resumen PDF de una rendición o liquidación (por su comprobante interno), con el aviso si falla.
 * `downloadingId` es el comprobante que se está descargando, para mostrar la carga en su botón.
 */
export default function useReceiptSummaryDownload() {
    const notify = useNotify();
    const [downloadingId, setDownloadingId] = useState<number | null>(null);

    const download = useCallback(async (receiptFormId: number, fileName: string) => {
        setDownloadingId(receiptFormId);
        try {
            await downloadReceiptSummary(receiptFormId, fileName);
        } catch (error: unknown) {
            parseApiError(error); // loguea errorCode y path para cruzarlo con el backend
            notify.error('No se pudo descargar el resumen. Intentá de nuevo.');
        } finally {
            setDownloadingId(null);
        }
    }, [notify]);

    return { download, downloadingId };
}
